// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollRateProfileForm_module__2yTuZ"};